export default "__VITE_ASSET__CLig8QFa__"